<template>
    <div>
        <h1>测试模块</h1>
        <h2>{{msg}}</h2>
    </div>
</template>
<script>
export default {
    data(){
        return {
            msg:'hello word!'
        }
    }
}
</script>